import gql from 'graphql-tag';
import { DollarApollo } from 'vue-apollo/types/vue-apollo';
import { User, UsersRole } from '@/store/modules/user';
import { addOrganizationToCurrentUser } from '@/queries/helpers/organizationHelpers';

export type OrganizationInvitation = {
  id: string;
  code: string;
  email: string;
  role: UsersRole;
  organization?: Organization;
  userAlreadyExists?: boolean;
  lastSentAt: string;
  resendCooldown: number;
};

export type Organization = {
  id: string;
  title: string;
  phoneNumber: string;
  address: string;
  users: User[];
  invitations: OrganizationInvitation[];
};

export const organizationUserFields = gql`
  fragment organizationUserFields on User {
    id
    email
    role
  }
`;

export const invitationFields = gql`
  fragment invitationFields on OrganizationInvitation {
    id
    code
    email
    role
    lastSentAt
    resendCooldown
  }
`;

export const organizationFields = gql`
  fragment organizationFields on Organization {
    id
    title
    phoneNumber
    address
    availableCredits
    users {
      ...organizationUserFields
    }
    invitations {
      ...invitationFields
    }
  }
  ${organizationUserFields}
  ${invitationFields}
`;

// Probably not in use
export const organizationMetaFields = gql`
  fragment organizationMetaFields on Organization {
    id
    title
    phoneNumber
    address
    availableCredits
  }
`;

const createOrganizationMutation = gql`
  mutation($data: CreateOrganizationInput!, $partnerCode: String) {
    createOrganization(data: $data, partnerCode: $partnerCode) {
      ...organizationFields
    }
  }
  ${organizationFields}
`;

interface OrganizationInput {
  title: string;
  phoneNumber: string;
  address: string;
}

export async function createOrganization(
  apollo: DollarApollo<any>,
  data: OrganizationInput,
  partnerCode?: string,
) {
  try {
    const createOrganizationResponse = await apollo.mutate({
      mutation: createOrganizationMutation,
      variables: {
        data,
        partnerCode,
      },
      update: (store: any, response: any) => {
        if (response == undefined) {
          return;
        }
        addOrganizationToCurrentUser(store, response.data.createOrganization);
      },
    });
    if (createOrganizationResponse.data == undefined) {
      throw new Error('Cannot get the organization');
    }
    return createOrganizationResponse.data.createOrganization;
  } catch (e) {
    throw e;
  }
}
